import { MenuItem, Select } from "@mui/material";
import { Videos } from "features/video/videoVariants";

type VideoSwitcherProps = {
  currentVideoId: string;
  onChange: (selectedKey: string) => void;
};

const VideoSwitcher = ({ currentVideoId, onChange }: VideoSwitcherProps) => {
  return (
    <Select
      value={currentVideoId}
      onChange={(e) => onChange(e.target.value as string)}
    >
      {Object.keys(Videos).map((key) => (
        <MenuItem key={key} value={key}>
          {key}
        </MenuItem>
      ))}
    </Select>
  );
};

export default VideoSwitcher;
